import { render, staticRenderFns } from "./FootbarMenu.vue?vue&type=template&id=5cd32641"
import script from "./FootbarMenu.vue?vue&type=script&lang=js"
export * from "./FootbarMenu.vue?vue&type=script&lang=js"
import style0 from "./FootbarMenu.vue?vue&type=style&index=0&id=5cd32641&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports